const loader = {
    init: () => {
        const threeButtons = document.querySelectorAll(`.open-three-d`);
        threeButtons.forEach(btn => {
            btn.addEventListener('click', e => {
                const threeData = e.target.dataset;
                loader.openThreeViewer(threeData);
            });
        });

    },

    openThreeViewer: (threeData) => {
        Promise.all([
            import('three'/* webpackChunkName: "vendor" */),
            import('@utilities/sal-three-viewer'/* webpackChunkName: "3d" */)
        ])
            .then(([THREE, salThreeViewerModule]) => {
                window.THREE = THREE;
                salThreeViewerModule.salThreeViewer.init(threeData);
            });
    }
};

export { loader };
